/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Sc_IssuesInputs */

const en_mk_tut_sc_issues = /** @type {(inputs: Mk_Tut_Sc_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jump to the issue list`)
};

const id_mk_tut_sc_issues = /** @type {(inputs: Mk_Tut_Sc_IssuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lompat ke daftar Issue`)
};

/**
* | output |
* | --- |
* | "Jump to the issue list" |
*
* @param {Mk_Tut_Sc_IssuesInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_sc_issues = /** @type {((inputs?: Mk_Tut_Sc_IssuesInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Sc_IssuesInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_sc_issues(inputs)
	return en_mk_tut_sc_issues(inputs)
});